import { render } from "./comboDetail.vue?vue&type=template&id=d876a9a8&scoped=true"
import script from "./comboDetail.vue?vue&type=script&lang=js"
export * from "./comboDetail.vue?vue&type=script&lang=js"

import "./comboDetail.vue?vue&type=style&index=0&id=d876a9a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d876a9a8"]])

export default __exports__